import { createTheme } from '@mui/material/styles';
import {PaletteColorOptions} from "@mui/material";

declare module '@mui/material/styles' {
    interface Palette {
        critic: PaletteColor;
    }
    interface PaletteColor {
        main: string;
        second: string;
    }
    interface TypeBackground {
        alternate?: string;
    }
    interface PaletteOptions {
        critic?: PaletteColorOptions;
    }
}

const theme = createTheme({
    palette: {
        primary: {
            main: '#183153',
        },
        secondary: {
            main: '#d45f3c',
        },
        error: {
            main: '#C84545',
        },
        background: {
            default: '#f3f1ec',
            paper: '#fffdf9',
            alternate: '#ebe7df',
        },
        critic: {
            main: '#62CD5D',
            light: '#507F9E'
        },
        text: {
            primary: '#17212f',
            secondary: '#657080'
        }
    },
    typography: {
        fontFamily: '"Segoe UI Variable", "Segoe UI", sans-serif',
        fontSize: 14,
        h4: { fontWeight: 700, letterSpacing: '-0.035em' },
        h5: { fontWeight: 700, letterSpacing: '-0.025em' },
        button: { fontWeight: 650, textTransform: 'none' }
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
        MuiButton: { styleOverrides: { root: { borderRadius: 10, minHeight: 42 } } },
        MuiTableCell: { styleOverrides: { head: { fontWeight: 700, color: '#485566', background: '#f2efe9' } } },
        MuiDialog: { styleOverrides: { paper: { borderRadius: 20, backgroundImage: 'none', boxShadow: '0 28px 90px rgba(24,49,83,.2)' } } },
        MuiDialogTitle: { styleOverrides: { root: { fontSize: '1.35rem', fontWeight: 750, letterSpacing: '-.02em', padding: '24px 28px 12px' } } },
        MuiDialogContent: { styleOverrides: { root: { padding: '16px 28px 24px' } } },
        MuiDialogActions: { styleOverrides: { root: { padding: '12px 28px 24px', gap: 8 } } },
        MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 11, backgroundColor: '#fffdf9' } } },
        MuiChip: { styleOverrides: { root: { fontWeight: 600 }, outlined: { backgroundColor: 'rgba(255,253,249,.7)' } } },
        MuiIconButton: { styleOverrides: { root: { borderRadius: 10, transition: 'background-color 180ms ease, transform 180ms ease', '&:hover': { transform: 'translateY(-1px)' } } } },
        MuiListItem: { styleOverrides: { root: { borderRadius: 12 } } },
    },
});

export default theme;
